import React, { FC } from "react";
import { useTranslation } from "react-i18next";

export const ActionButtons: FC<{
  onCloseButtonClick: () => void;
  onApplyButtonClick: () => void;
}> = ({ onCloseButtonClick, onApplyButtonClick }) => {
  const { t } = useTranslation("productListing");
  return (
    <div className="apply_buttons_wrapper">
      <button className="close_button" onClick={() => onCloseButtonClick()}>
        {t("filterClose")}
      </button>
      <button className="apply_button" onClick={() => onApplyButtonClick()}>
        {t("filterApply")}
      </button>
    </div>
  );
};
